import { PEAD } from "../../../consts";
import type { ChartData, ChartDataState } from "../../../types";

export function generateChartMap(
	lines: ChartDataState,
	timeLine: number[],
	priceLine: ChartData = [],
): Map<string, ChartData> {
	const map: Map<string, ChartData> = new Map();

	for (const _ of timeLine) {
		map.set(PEAD.LINE.AVG, lines.movingAverage);
		map.set(PEAD.LINE.MAX, lines.maxMovingAverage);
		map.set(PEAD.LINE.MIN, lines.minMovingAverage);
		map.set(PEAD.LINE.SIGMA_1, lines.sigma1);
		map.set(PEAD.LINE.SIGMA_2, lines.sigma2);
		map.set(PEAD.LINE.SIGMA_MINUS_1, lines.sigmaMinus1);
		map.set(PEAD.LINE.SIGMA_MINUS_2, lines.sigmaMinus2);
		map.set(PEAD.LINE.PRICE, priceLine);
	}

	return map;
}
